// extracted by mini-css-extract-plugin
var _1 = "subscribe-today_additional__z8B9y";
var _2 = "subscribe-today_confirm__8Qfh+";
var _3 = "subscribe-today_desktopLayout__jXPGz";
var _4 = "subscribe-today_desktopPlaceholder__LuTQ-";
var _5 = "subscribe-today_mobileLayout__g-WwG";
var _6 = "subscribe-today_plans__xhtFL";
var _7 = "subscribe-today_purchase__JNJmA";
export { _1 as "additional", _2 as "confirm", _3 as "desktopLayout", _4 as "desktopPlaceholder", _5 as "mobileLayout", _6 as "plans", _7 as "purchase" }
